export default {
	MassLetterSendMessage: "MassLetterSendMessage",
	ResetMassLetter: "ResetMassLetter",
	MassLetterCancelMessage: "MassLetterCancelMessage",
	MassLetterOpenChat: "MassLetterOpenChat",
	MassLetterShowPopupCountUpdate: "MassLetterShowPopupCountUpdate",
};
